import { render, staticRenderFns } from "./CustomerNotificationStepZero.vue?vue&type=template&id=8c53a088&"
import script from "./CustomerNotificationStepZero.vue?vue&type=script&lang=js&"
export * from "./CustomerNotificationStepZero.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports